import { render, staticRenderFns } from "./SelectMultipleUsersChipTruncate.vue?vue&type=template&id=316e0b9a&scoped=true"
import script from "./SelectMultipleUsersChipTruncate.vue?vue&type=script&lang=js"
export * from "./SelectMultipleUsersChipTruncate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316e0b9a",
  null
  
)

export default component.exports